// src/api/axiosInstance.js
import axios from "axios";
import { getAuth, onIdTokenChanged } from "firebase/auth";
import { firebaseApp } from "../firebase/firebaseApp";

const baseURL = process.env.REACT_APP_API_BASE || "/";

const api = axios.create({ baseURL: baseURL, timeout: 10_000 });

// cache the latest token
let idToken = null;
onIdTokenChanged(getAuth(firebaseApp), async (u) => {
  idToken = u ? await u.getIdToken() : null;
});

api.interceptors.request.use((cfg) => {
  if (idToken) cfg.headers.Authorization = `Bearer ${idToken}`;
  return cfg;
});

export default api;
